import {Mask} from './Mask';
import {MaskImpl} from './MaskImpl';

export class MaskCard extends MaskImpl implements Mask {

    public normalize(value: string): string {
        var onlyNums = value.replace(/[^\d]/g, '');
        if (onlyNums.length <= 4) {
            return onlyNums;
        }
        if (onlyNums.length <= 8) {
            return onlyNums.slice(0, 4) + ' ' + onlyNums.slice(4, 8);
        }
        if (onlyNums.length <= 12) {
            return onlyNums.slice(0, 4) + ' ' + onlyNums.slice(4, 8) + ' ' + onlyNums.slice(8, 12);
        }
        if (onlyNums.length <= 16) {
            return onlyNums.slice(0, 4) + ' ' + onlyNums.slice(4, 8) + ' ' + onlyNums.slice(8, 12) + ' ' + onlyNums.slice(12, 16);
        }
        return onlyNums.slice(0, 4) + ' ' + onlyNums.slice(4, 8) + ' ' + onlyNums.slice(8, 12) + ' ' + onlyNums.slice(12, 16) + ' ' + onlyNums.slice(16, 19);
    }

}
